module.exports = __webpack_public_path__ + "static/media/setup.ae2278b0.svg";